import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  size?: 'default' | 'large';
  showArrow?: boolean;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  href,
  size = 'default',
  showArrow = true,
  className = ''
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'px-10 py-5 text-lg md:text-xl' : 'px-8 py-4 text-base md:text-lg';
  const sharedClasses = `
    group relative inline-flex items-center justify-center gap-3
    ${sizeClasses}
    font-semibold tracking-wide
    text-[#0a0e1a]
    bg-gradient-to-r from-[#c9a84c] via-[#f0d060] to-[#c9a84c]
    bg-[length:200%_auto]
    rounded-lg
    cta-pulse
    transition-all duration-500 ease-out
    hover:bg-[position:right_center]
    hover:scale-[1.03]
    hover:shadow-[0_0_40px_rgba(201,168,76,0.4)]
    active:scale-[0.98]
    focus:outline-none focus:ring-2 focus:ring-[#d4af37] focus:ring-offset-2 focus:ring-offset-[#0a0e1a]
    cursor-pointer
    ${className}
  `;
  const content = <>
      <span data-id="element-458">{children}</span>
      {showArrow && <ArrowRightIcon className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-id="element-459" />}
    </>;
  if (href) {
    return <a href={href} onClick={onClick} className={sharedClasses} style={{
      textDecoration: 'none'
    }} data-id="element-460">
        {content}
      </a>;
  }
  return <a href="https://pay.hotmart.com/L104469229P" target="_blank" rel="noopener noreferrer" onClick={onClick} className={sharedClasses} style={{
    textDecoration: 'none'
  }} aria-label={typeof children === 'string' ? children : undefined} data-id="element-461">
      {content}
    </a>;
}